// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils from "../utils/ErrorUtils.bs.jsx";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

let CancelledByUser = /* @__PURE__ */Primitive_exceptions.create("FirebaseWebAuthn.CancelledByUser");

let InvalidFunctionResponse = /* @__PURE__ */Primitive_exceptions.create("FirebaseWebAuthn.InvalidFunctionResponse");

let NoOperationNeeded = /* @__PURE__ */Primitive_exceptions.create("FirebaseWebAuthn.NoOperationNeeded");

function toFirebaseWebAuthnError(exn) {
  if (exn.RE_EXN_ID !== "JsExn") {
    return exn;
  }
  let match = ErrorUtils.code(exn._1);
  if (match === undefined) {
    return exn;
  }
  switch (match) {
    case "firebaseWebAuthn/cancelled" :
      return {
        RE_EXN_ID: CancelledByUser
      };
    case "firebaseWebAuthn/invalid" :
      return {
        RE_EXN_ID: InvalidFunctionResponse
      };
    case "firebaseWebAuthn/no-op" :
      return {
        RE_EXN_ID: NoOperationNeeded
      };
    default:
      return exn;
  }
}

export {
  CancelledByUser,
  InvalidFunctionResponse,
  NoOperationNeeded,
  toFirebaseWebAuthnError,
}
/* No side effect */
